__turbopack_context__.v({
  "Round": "herocarousel-module-scss-module__i_X0rW__Round",
  "active": "herocarousel-module-scss-module__i_X0rW__active",
  "bgGradient": "herocarousel-module-scss-module__i_X0rW__bgGradient",
  "buttonGroup": "herocarousel-module-scss-module__i_X0rW__buttonGroup",
  "carouselButton": "herocarousel-module-scss-module__i_X0rW__carouselButton",
  "container": "herocarousel-module-scss-module__i_X0rW__container",
  "contentLayer": "herocarousel-module-scss-module__i_X0rW__contentLayer",
  "copyright": "herocarousel-module-scss-module__i_X0rW__copyright",
  "fgBelow": "herocarousel-module-scss-module__i_X0rW__fgBelow",
  "foregroundDesktop": "herocarousel-module-scss-module__i_X0rW__foregroundDesktop",
  "foregroundMobile": "herocarousel-module-scss-module__i_X0rW__foregroundMobile",
  "gridContainer": "herocarousel-module-scss-module__i_X0rW__gridContainer",
  "header": "herocarousel-module-scss-module__i_X0rW__header",
  "headerCol": "herocarousel-module-scss-module__i_X0rW__headerCol",
  "noBreadcrumbPlaceholder": "herocarousel-module-scss-module__i_X0rW__noBreadcrumbPlaceholder",
  "offscreen": "herocarousel-module-scss-module__i_X0rW__offscreen",
  "preload": "herocarousel-module-scss-module__i_X0rW__preload",
  "pznMessageWrapper": "herocarousel-module-scss-module__i_X0rW__pznMessageWrapper",
  "rightColumn": "herocarousel-module-scss-module__i_X0rW__rightColumn",
  "thumbnailsAbove": "herocarousel-module-scss-module__i_X0rW__thumbnailsAbove",
});
